import { gql } from "@apollo/client"
export const ADD_SESSION_NOTE_MUTATION = gql(/* GraphQL */`
    mutation AddSessionNote($sessionId: UUID! $type: NoteTypeEnum!, $body: String!, $origin: NoteOriginType!) {
        addSessionNote(input: { sessionId: $sessionId, type: $type, body: $body, origin:$origin }) {
            __typename
            errors {
                __typename
                ... on UnknownError {
                    message
                }
                ... on ValidationError {
                    message
                    errors {
                        fieldName
                        messages
                    }
                }
            }
        }
    }
`);